module.exports = __webpack_public_path__ + "static/media/plus-badge@3x.7c694f93.png";